import _find from 'lodash/find';
import _groupBy from 'lodash/groupBy';
import _map from 'lodash/map';
import _sumBy from 'lodash/sumBy';
import { selectStackedBardChartData } from '../../../../utils';

/**
 * @param answer for frequency graph  the answers going to include a number that represent the frequency
 * @returns any of 'never', 'rarely', 'sometimes', 'often', 'always' or the initial answer if doesn't match with other
 */
export const getAliasAnswerStackedChart = (answer, aliasAnswers) =>
  _find(aliasAnswers, (value, key) =>
    answer.includes(key) ? value : undefined
  ) || answer;

/**
 * function allow join all the answers in a format to present correctly the chart
 * @param insightsData
 * @param aliasesObject
 * @returns [{ answer: string, [frequencyKey]: number }]
 */
export const getFormattedDataStackedBarChart = (
  insightsData,
  answerAliasesObject
) => {
  const stackedBarChart = selectStackedBardChartData(insightsData);
  const questions = _groupBy(stackedBarChart, 'question_text');
  return _map(questions, (data) => {
    const total = _sumBy(data, (item) => parseInt(item.student_count));
    return data.reduce(
      (accum, item) => {
        const keyAnswer = getAliasAnswerStackedChart(
          item.answer,
          answerAliasesObject
        );
        if (item.student_count > 0) {
          accum[keyAnswer] = (item.student_count * 100) / total;
          accum.answer = item.display_text;
          accum.originalData[keyAnswer] = parseInt(item.student_count);
        }
        return accum;
      },
      { originalData: {} }
    );
  });
};
